export default __webpack_public_path__ + "static/media/Appstore-Icon.4c5bba8f.png";